<template>
  <div>
    <p class="content">
      Next we need need some basic information about your company.
      <br/>
      Your tax ID is important because it allow us to uniquely identify your organization. If you have a DUNS number please provide it as well.
    </p>
    <company-info ref="form" v-model="companyInfo" @isComplete="notify" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CompanyInfo from '@/components/FormCompanyInformation'
export default {
  name: 'Registration-CompanyInfo',

  data() {
    return {
      companyInfo: {}
    }
  },

  async created() {
    try {
      // first time this View is created... check for an existing company and kick them to dashboard if they already
      // have one, since it means they are done with registration.
      await this.getCompanyDetails()
      this.$router.push({ name: 'dashboard' })
    } catch (e) {
      // do nothing, just means they do not have a company
    }
  },

  async activated() {
    // because of the `<keep-alive>` tag used for the registration sub-views.... the "activated" hook gets called when
    // switching between sub-views. At that point we want to re-validate the form to make sure they can keep going.
    // The assumption is that it will already be filled out... so this is really just to make sure the "next" button is
    // enabled.

    if (this.currentCompanyInfo.companyKey) {
      const isValid = await this.$refs['form'].validate()

      if (isValid) {
        this.notify(true)
      }
    }
  },

  components: {
    CompanyInfo
  },

  computed: {
    ...mapState('user', { userInfo: 'currentUserInfo' }),
    ...mapState('company', ['currentCompanyInfo'])
  },

  methods: {
    ...mapActions('registration', ['registerCompany']),
    ...mapActions('company', { getCompanyDetails: 'getDetails' }),

    notify(isFormComplete) {
      this.$emit('canBeSubmitted', isFormComplete)
    },

    /**
     * Actually register the user/account
     * @returns {Promise<void>}
     */
    async register() {
      const isValid = await this.$refs['form'].validate()

      if (!isValid) {
        this.notify(false)
        return
      }

      await this.registerCompany(this.companyInfo)
      /*
      if (!this.userIsAdmin) {
        const inviteInfo = {
          inviteAccountFirstName: this.admin.firstName,
          inviteAccountLastName: 'this.admin.lastName',
          // inviteAccountType: 'carrier',
          inviteAccountEmailAddress: this.admin.email,
          invitePhone: this.admin.phone,
          inviteToCompanyKey: this.currentCompanyInfo.companyKey
        }
        await InviteApi.inviteToCompany(inviteInfo)

      }
      */
    }
  }
}
</script>

<style scoped>
</style>
